import {sendRequest} from "./rootApi";
import Api from "../constants/Api";
import HttpRequest from "./HttpRequest";

export const getPackagesList = async (payload) => {
    return sendRequest("post", Api.packagesList, payload.form_data);
};

export const buyNewPackage = async (payload) => {
  return HttpRequest.post(Api.buyNewPackage, payload);
};